// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-28e4c148] {\n  height: 8rem;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
